import { feathers } from '@feathersjs/feathers';
import rest from "@feathersjs/rest-client";
import { HIMES_NODE_API, tenant_id } from '../components/common';

let refreshPromise = null;

const dynamicFetch = async (url, options = {}) => {
  const token = localStorage.getItem('accessToken');
  console.log('token',token);
  const appVersion = localStorage.getItem('app_version');
  console.log('appVersion', appVersion);
  const headers = {
    ...options.headers,
  };
  if (appVersion) {
    headers['app-version'] = appVersion;
  }
  
  // Preserve custom tenant-id (e.g. 'multitenant_maindb' for version fetching), fallback to tenant_id
  const tenantId = headers['x-tenant-id'] || headers['X-Tenant-Id'] || tenant_id;
  delete headers['X-Tenant-Id'];
  headers['x-tenant-id'] = tenantId;

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  let response = await window.fetch(url, { ...options, headers });

  if (response.status === 401) {
    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
      handleLogout();
      return response;
    }

    if (!refreshPromise) {
      refreshPromise = (async () => {
        try {
          const refreshResponse = await window.fetch(`${HIMES_NODE_API}/mobileauth`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-tenant-id': tenant_id,
              'X-Service-Method': 'refreshAccessToken',
              'x-app-key': 'MOBILE_APP_SECURE_20261609_KEY'
            },
            body: JSON.stringify({ refreshToken })
          });

          if (!refreshResponse.ok) throw new Error('Refresh failed');

          const refreshData = await refreshResponse.json();

          if (refreshData.status === true && refreshData.accessToken) {
            localStorage.setItem('accessToken', refreshData.accessToken);
            if (refreshData.refreshToken) {
              localStorage.setItem('refreshToken', refreshData.refreshToken);
            }
            return true;
          }
          return false;
        } catch (err) {
          return false;
        } finally {
          refreshPromise = null;
        }
      })();
    }

    const isRefreshed = await refreshPromise;

    if (isRefreshed) {
      const newToken = localStorage.getItem('accessToken');
      headers['Authorization'] = `Bearer ${newToken}`;
      return window.fetch(url, { ...options, headers });
    } else {
      handleLogout();
    }
  }

  return response;
};

const handleLogout = () => {
  const savedAppVersion = localStorage.getItem('app_version');
  localStorage.clear();
  sessionStorage.clear();
  if (savedAppVersion) {
    localStorage.setItem('app_version', savedAppVersion);
  }
  window.location.href = '/login';
};

export const FeatherClient = async () => {
  const feathersClient = feathers();
  const restClient = rest(HIMES_NODE_API).fetch(dynamicFetch);
  feathersClient.configure(restClient);
  return feathersClient;
}

export const getToken = async () => {
  try {
    const tokens = localStorage.getItem('accessToken');
    return tokens;
  } catch (error) {
    console.error('Error token data:', error);
  }
};

export const setToken = async (token) => {
  try {
    localStorage.setItem('accessToken', token);
  } catch (error) {
    console.error('Error token data:', error);
  }
};